import { inject, Injectable } from "@angular/core";

import {
    HtmlSequence,
    HtmlDirective,
    HtmlDirectiveEvaluator,
    HtmlDirectiveEvaluatorSettings,
} from "@main/reporting.v3/widget.html/models";
import {
    HtmlBaseExpressionsArgumentService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-base-expressions-argument.service";


@Injectable()
export class HtmlNumberDirectiveService implements HtmlDirectiveEvaluator {

    private argumentService: HtmlBaseExpressionsArgumentService = inject(HtmlBaseExpressionsArgumentService);

    public readonly directive: string = "number";

    public async evaluate(directive: HtmlDirective, settings: HtmlDirectiveEvaluatorSettings): Promise<any> {
        if (!directive || directive.name !== this.directive || !settings) return null;

        const arg: HtmlSequence = directive.arguments[0];
        const param: any = await this.argumentService.evaluate(arg, settings);
        const value: number = this.argumentService.toNumber(param) ?? 0;

        return value;
    }
}